import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { clients, profits } from '@/mocks/clients';

interface ToastData {
  client: { name: string; city: string };
  profit: { amount: string; contract: string };
  id: number;
}

const EarningsToast = () => {
  const { t } = useTranslation();
  const [toast, setToast] = useState<ToastData | null>(null);
  const [visible, setVisible] = useState(false);

  const showNext = useCallback(() => {
    const client = clients[Math.floor(Math.random() * clients.length)];
    const profit = profits[Math.floor(Math.random() * profits.length)];
    setToast({ client, profit, id: Date.now() });
    setVisible(true);

    // Скрываем через 3.5 сек
    setTimeout(() => setVisible(false), 3500);
  }, []);

  useEffect(() => {
    // Первый показ через 2 сек
    const initial = setTimeout(showNext, 2000);
    // Потом каждые 5 сек
    const interval = setInterval(showNext, 5000);
    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, [showNext]);

  if (!toast) return null;

  return (
    <div
      className="fixed bottom-6 left-4 z-[9998] transition-all duration-500"
      style={{
        transform: visible ? 'translateX(0)' : 'translateX(-120%)',
        opacity: visible ? 1 : 0,
      }}
    >
      <div className="bg-[#0d1a0d] border border-green-500/40 rounded-2xl px-4 py-3 flex items-start gap-3 max-w-[280px]"
        style={{ boxShadow: '0 0 20px rgba(34,197,94,0.15)' }}
      >
        {/* Пульсирующий зелёный индикатор */}
        <div className="flex-shrink-0 mt-0.5 relative">
          <div className="w-2.5 h-2.5 bg-green-400 rounded-full" />
          <div className="absolute inset-0 w-2.5 h-2.5 bg-green-400 rounded-full animate-ping opacity-60" />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 mb-0.5">
            <span className="text-white font-semibold text-sm truncate" style={{ fontFamily: "'Inter', sans-serif" }}>
              {toast.client.name}
            </span>
            <span className="text-white/40 text-xs flex-shrink-0">{toast.client.city}</span>
          </div>
          <div className="text-xs text-white/55 mb-1" style={{ fontFamily: "'Inter', sans-serif" }}>
            {t('toast_earned')} <span className="text-white/75">{toast.profit.contract}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-green-400 font-black text-lg leading-none" style={{ fontFamily: "'Oswald', sans-serif" }}>
              +{toast.profit.amount}
            </span>
            <span className="text-white/35 text-xs">{t('toast_period')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EarningsToast;